// Estructura del contenido de ayuda (panel de ayuda).
// La ESTRUCTURA (orden, data-testid target, ids) vive aqui; los TEXTOS son claves
// i18n resueltas con t() en el componente. target=null => paso solo instructivo
// (sin resaltado). Los data-testid ya existen en las paginas; no se tocan.
export const HELP_CONTENT = {
  dashboard: {
    tabs: [
      {
        id: 'docs',
        titleKey: 'help.dashboard.docs.title',
        checklist: [
          { id: 'crear', key: 'help.dashboard.docs.steps.crear', target: 'create-doc-button' },
          { id: 'titulo', key: 'help.dashboard.docs.steps.titulo', target: null },
          { id: 'abrir', key: 'help.dashboard.docs.steps.abrir', target: null },
          { id: 'borrar', key: 'help.dashboard.docs.steps.borrar', target: null },
        ],
        refs: [
          { id: 'nuevo', key: 'help.dashboard.docs.refs.nuevo', target: 'create-doc-button', detailKey: 'help.dashboard.docs.refs.nuevo_detail' },
          { id: 'card', key: 'help.dashboard.docs.refs.card', target: null },
        ],
      },
      {
        id: 'topbar',
        titleKey: 'help.dashboard.topbar.title',
        checklist: [
          { id: 'config', key: 'help.dashboard.topbar.steps.config', target: 'config-button' },
        ],
        refs: [
          { id: 'config', key: 'help.dashboard.topbar.refs.config', target: 'config-button', detailKey: 'help.dashboard.topbar.refs.config_detail' },
          { id: 'imgs', key: 'help.dashboard.topbar.refs.imgs', target: 'cleanup-images-button', detailKey: 'help.dashboard.topbar.refs.imgs_detail' },
          { id: 'admin', key: 'help.dashboard.topbar.refs.admin', target: 'admin-button', detailKey: 'help.dashboard.topbar.refs.admin_detail' },
          { id: 'salir', key: 'help.dashboard.topbar.refs.salir', target: 'logout-button' },
        ],
      },
    ],
  },
  editor: {
    tabs: [
      {
        id: 'escribir',
        titleKey: 'help.editor.escribir.title',
        checklist: [
          { id: 'edit', key: 'help.editor.escribir.steps.edit', target: 'tiptap-editor' },
        ],
        refs: [
          { id: 'back', key: 'help.editor.escribir.refs.back', target: 'back-button' },
        ],
      },
      {
        id: 'ia',
        titleKey: 'help.editor.ia.title',
        checklist: [
          { id: 'flotante', key: 'help.editor.ia.steps.flotante', target: 'floating-ai-button' },
          { id: 'comandos', key: 'help.editor.ia.steps.comandos', target: 'commands-button' },
          { id: 'chat', key: 'help.editor.ia.steps.chat', target: 'chat-sidebar' },
          { id: 'modelo', key: 'help.editor.ia.steps.modelo', target: null },
          { id: 'plantilla', key: 'help.editor.ia.steps.plantilla', target: null },
          { id: 'flujos', key: 'help.editor.ia.steps.flujos', target: 'flows-button' },
          { id: 'contexto', key: 'help.editor.ia.steps.contexto', target: null },
        ],
        refs: [
          { id: 'flotante', key: 'help.editor.ia.refs.flotante', target: 'floating-ai-button', detailKey: 'help.editor.ia.refs.flotante_detail' },
          { id: 'comandos', key: 'help.editor.ia.refs.comandos', target: 'commands-button', detailKey: 'help.editor.ia.refs.comandos_detail' },
          { id: 'chat', key: 'help.editor.ia.refs.chat', target: 'chat-sidebar', detailKey: 'help.editor.ia.refs.chat_detail' },
          { id: 'modelo', key: 'help.editor.ia.refs.modelo', target: null, detailKey: 'help.editor.ia.refs.modelo_detail' },
          { id: 'plantilla', key: 'help.editor.ia.refs.plantilla', target: null, detailKey: 'help.editor.ia.refs.plantilla_detail' },
          { id: 'flujos', key: 'help.editor.ia.refs.flujos', target: 'flows-button', detailKey: 'help.editor.ia.refs.flujos_detail' },
          { id: 'contexto', key: 'help.editor.ia.refs.contexto', target: null, detailKey: 'help.editor.ia.refs.contexto_detail' },
          { id: 'transparencia', key: 'help.editor.ia.refs.transparencia', target: null, detailKey: 'help.editor.ia.refs.transparencia_detail' },
        ],
      },
      {
        id: 'documento',
        titleKey: 'help.editor.documento.title',
        checklist: [
          { id: 'exportar', key: 'help.editor.documento.steps.exportar', target: 'export-button' },
          { id: 'comparar', key: 'help.editor.documento.steps.comparar', target: 'diff-button' },
        ],
        refs: [
          { id: 'exportar', key: 'help.editor.documento.refs.exportar', target: 'export-button', detailKey: 'help.editor.documento.refs.exportar_detail' },
          { id: 'prompt', key: 'help.editor.documento.refs.prompt', target: 'prompt-button', detailKey: 'help.editor.documento.refs.prompt_detail' },
          { id: 'comparar', key: 'help.editor.documento.refs.comparar', target: 'diff-button', detailKey: 'help.editor.documento.refs.comparar_detail' },
          { id: 'orient', key: 'help.editor.documento.refs.orient', target: 'orientation-toggle-button' },
        ],
      },
      {
        id: 'notas',
        titleKey: 'help.editor.notas.title',
        checklist: [
          { id: 'comentar', key: 'help.editor.notas.steps.comentar', target: 'comments-toggle-button' },
        ],
        refs: [
          { id: 'comentar', key: 'help.editor.notas.refs.comentar', target: 'comments-toggle-button', detailKey: 'help.editor.notas.refs.comentar_detail' },
        ],
      },
      {
        id: 'referencias',
        titleKey: 'help.editor.referencias.title',
        checklist: [
          { id: 'chip', key: 'help.editor.referencias.steps.chip', target: null },
          { id: 'modal', key: 'help.editor.referencias.steps.modal', target: null },
        ],
        refs: [
          { id: 'export', key: 'help.editor.referencias.refs.export', target: null, detailKey: 'help.editor.referencias.refs.export_detail' },
        ],
      },
      {
        // Faltaba: la ayuda no cubría créditos, tema ni el logout DEL EDITOR
        // (solo documentaba el del dashboard). Con el paywall activo, los
        // créditos son de las primeras cosas que un usuario nuevo pregunta.
        id: 'sesion',
        titleKey: 'help.editor.sesion.title',
        checklist: [
          { id: 'tema', key: 'help.editor.sesion.steps.tema', target: null },
        ],
        refs: [
          { id: 'creditos', key: 'help.editor.sesion.refs.creditos', target: null, detailKey: 'help.editor.sesion.refs.creditos_detail' },
          { id: 'ui', key: 'help.editor.sesion.refs.ui', target: null, detailKey: 'help.editor.sesion.refs.ui_detail' },
          { id: 'salir', key: 'help.editor.sesion.refs.salir', target: 'editor-logout-button', detailKey: 'help.editor.sesion.refs.salir_detail' },
        ],
      },
    ],
  },
};
